module.exports = __webpack_public_path__ + "static/media/19ESCAP10.69ed667d.jpg";